// extracted by mini-css-extract-plugin
module.exports = {"content":"MainLayout_content__R2I5n","drawerOpen":"MainLayout_drawerOpen__5s7Tm"};